export default {
  table: {
    index: '序号',
    time: '操作时间',
    remark: '变更信息',
    title: '多值选择',
    name: '数值',
  },
  error: {
    network: '请求错误，未找到请求资源。',
    timeout: '请求超时，请联系管理员。',
    clickError: '抱歉，暂未找到执行方法',
  },
  login: {
    title: '欢迎登录',
    subtitle: '物产化工智慧供应链平台',
    logIn: '登录',
    usernameNotEmpty: '用户名不能为空',
    passwordNotEmpty: '密码不能为空',
    verificationNotEmpty: '验证码不能为空',
    username: '用户账号',
    password: '密码',
    verificationCode: '验证码',
    forget: '忘记密码,寻求帮助？',
    changePassword: '修改密码',
    userAccount: '账号',
    beforePassword: '原密码',
    newPassword: '新密码',
    userAccountEmpty: '账号不能为空',
    beforePasswordEmpty: '原密码不能为空',
    newPasswordEmpty: '新密码不能为空',
    newPasswordEmptyOne: '密码需包含英文和数字，长度最少8位',
    newPasswordEmptyTwo: '新密码只能输入字母和数字',
    againNewPasswordEmpty: '请再次输入密码',
    againNewPasswordEmptys: '两次密码必须一致',
    againNewPassword: '再次输入密码',
  },
  search: {
    search: '搜索',
    reset: '重置',
    packUp: '收起',
    spread: '展开',
    input: '请输入',
    choose: '请选择',
    to: '至',
    start: '开始日期',
    end: '结束日期',
    nosearchError: '请输入至少一条查询条件进行查询',
    radio: ' ',
  },
  placeholder: {
    auto: '自动生成',
  },
  confirm: {
    delete: '删除数据？',
    content: '是否确认删除？',
    tips: '删除父节点，将连同子节点一起删除！',
    confirm: '确定',
    cancel: '取消',
    deleteCancelled: '已取消',
    forbid: '禁用数据？',
    forbidContent: '是否确认禁用？',
    lift: '启用数据？',
    liftContent: '是否确认启用？',
    repeatContent: '该数据可能存在',
    repeat: '点击查看详情',
    remove: '放弃数据？',
    removeContent: '是否确认放弃？',
    removeSend: '取消发送？',
    removeSendContent: '是否确认取消发送？',
    revert: '撤销数据？',
    revertContent: '是否确认撤销数据？',
    missionCannotCancelled: '该任务已不能取消',
    submit: '提交审批？',
    removeSubmit: '是否确认提交审批？',
    donNotEmoticons: '请勿输入表情',
    updatePassword: '修改密码',
    loginout: '退出登录',
    batchSubmit: '批量提交？',
    removeBatchSubmit: '是否确认批量提交？',
  },
  alert: {
    error: '操作失败！',
    confirm: '确定',
    save: '保存',
    submit: '提交',
  },
  message: {
    query: '有疑问么？',
    messageCenter: '消息中心',
    have: '有',
    badgeNumber: '条未读消息',
    success: '操作成功',
    delSuccess: '删除成功',
    cancle: '删除操作已取消',
    yes: '是',
    no: '否',
    validateFalse: '校验不通过',
    saveSussess: '保存成功！',
    deleteSuccess: '删除成功！',
    noData: '您还未选择任何数据！',
    cancelled: '已取消！',
    noExport: '当前没有数据可以导出！',
  },
  dialog: {
    save: '保存',
    submit: '提交',
    confirm: '确定',
    send: '发送',
    cancel: '取消',
  },
  fix: {
    column: '固定列不可以拖动',
  },
  tagsView: {
    refresh: '刷新',
    close: '关闭',
    closeOthers: '关闭其它',
    closeAll: '关闭所有',
  },
  import: {
    importTitle: '导入数据',
    chooseFile: '选择文件',
    submitImport: '开始导入',
    importType: '上传文件只能是 xls、xlsx格式!',
    importLimit: '上传文件大小不能超过 20MB!',
    importTips: '只能上传xls/xlsx文件，且不超过20M',
    importSuccess: '导入成功',
    downLoadTemp: '下载模板',
  },
  xTable: {
    total: '合计',
    insert: '新增',
    delete: '删除',
    save: '保存',
    disable: '禁用',
    inabled: '启用',
    selectOne: '请选择一条数据！',
    onlyOneChange: '只能增加一行数据',
    noSelectData: '请至少选择一条数据！',
    onlyOneSelect: '只能选择一条数据',
    saveNoData: '请至少选择一条产品',
    oneSelectData: '请选择一条数据！',
    disableDel: '当前数据已经被后续引用，不能删除',
    disableDelStatus: '的合同不能删除',
    toolbar: {
      custom: '自定义列',
      allTitle: '全选/取消',
      customAll: '全部',
    },
  },
  functionBtn: {
    export: '导出',
    add: '新增',
    save: '保存',
    refresh: '刷新',
    commit: '提交',
    confirm: '确认',
    approval: '提交审批',
    edit: '修改',
    disable: '禁用',
    inable: '解禁用',
    delete: '删除',
    quit: '放弃',
    revert: '撤销',
    copy: '复制',
    print: '打印',
    withdraw: '撤回',
    return: '退回',
    writeOff: '冲销',
    editToggle: '修改/显示',
    generateCredentials: '生成凭证',
    doSyncVoucher: '过账凭证',
    enable: '生效',
  },
};
